
import { format } from 'date-fns'

import Vue from 'vue'
import Router from 'vue-router'

import VueScrollTo from 'vue-scrollto'
import miniToastr from 'mini-toastr'
import VueCollapse from 'vue2-collapse'
import VTooltip from 'v-tooltip'
import axios from 'axios'
import globalMixin from '../mixins/global.js'

 import 'vue-datetime/dist/vue-datetime.css'

import SpiritualApp from '../SpiritualApp.vue'
import router from '../router/spiritual.js'
import store from '../store/index.js'

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(VTooltip)

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({ types: toastTypes })

Vue.use(Router)
Vue.use(VueCollapse)

Vue.filter('formatDate', (value, formatStr) => {
  if (value) {
    if (!formatStr) {
      // eslint-disable-next-line
      formatStr = 'MM/dd/yyyy HH:MM';
    }
    if (formatStr === 'at') {
      return `${format(new Date(value), 'MM/dd/yyyy')} at ${format(new Date(value), 'HH:mm')}`
    }
    return format(new Date(value), formatStr)
  }
  return value
})


Vue.mixin(globalMixin.notificationMixin())

const token = localStorage.getItem('token')
if (token) {
  // eslint-disable-next-line
  axios.defaults.headers.common['Authorization'] = token;

}

/* eslint-disable no-new */
new Vue({
  el: '#spiritual-app',
  router,
  store,
  render: h => h(SpiritualApp)
})
